import sha256 from "js-sha256";

const cardTitle = (card, title) => $obj => {
    let $title = $obj.closest(card).querySelector(title);

    return $title ? $title.textContent.trim() : '';
};
const newsCardTitle = cardTitle('.wc-news-card', '.wc-news-card__title a');
const authorPostTitle = cardTitle('.wc-author-post', '.wc-author-post__title a');
const linkTitle = title => $obj => {
    let $title = $obj.querySelector(title);

    return $title ? $title.textContent.trim() : '';
};
const pageTitle = () => (document.querySelector('h1') || {textContent: ''}).textContent.trim();

/**
 * Legacy wizcase.com's button names for links that carry none, matched with closest(): the selector, the
 * name, the label if not the link's text and the action if legacy's was not the link's own
 */
const WIZCASE_AREAS = [
    ['.wc-header__logo', 'Wizcase - Home'],
    ['.wc-lang__list', 'Lang Switcher - Not Active lang'],
    ['.wc-nav__social', 'Navigation Social Media - Social Link'],
    ['.wc-nav__sub-link', 'Main Menu - Submenu Link'],
    ['.wc-nav__link', 'Main Menu - Primary Link'],
    ['.breadcrumbs', 'Breadcrumbs - Link'],
    ['.wc-toc', 'Sidebar - Table of Contents'],
    ['.wc-post-share, .wc-share-support__share', 'Follow the expert'],
    ['.wc-author__socials', 'Author Socials - Link'],
    ['.author .author-name', 'Footer Written By - Author Link'],
    ['.wc-footer__tm-link', 'Testing Methodology - Footer Mission Link', 'Testing Methodology'],
    ['.wc-footer__block:last-child .wc-footer__links', 'Footer Menu Link'],
    ['.wc-footer__links', 'Footer Menu - Menu Link'],
    ['.wc-bottom-nav', 'Organic Navigation Mobile - Floating Menu'],
    //a blog card is one link where legacy had four (image, title, author, read more); "Load more" was its next page
    ['.category-blog .blogposts-list .single-post', 'Blog Article - Title Link', $obj => $obj.getAttribute('title')],
    ['.category-blog .load-more', 'Blog Pagination - Blog Next', 'Blog'],
    //the front page's post cards carry their "Category List <vertical>" names, see FrontPage::card()
    ['.wc-home-trending__image', 'Trending Articles - Article Feature Image', 'Homepage'],
    ['.wc-home-trending__name', 'Trending Articles - Article Title', 'Homepage'],
    ['.wc-home-trending__vertical', 'Trending Articles - Article Flat Table', 'Homepage'],
    ['.wc-home-team__intro', 'Meet the Team - Read More About Us Link', 'News Homepage'],
    ['.wc-home-team__link', 'Meet the Team - Author Block', 'Homepage'],
    ['.wc-home-team__socials', 'Meet the Team - Author Social Links', '', 'click in'],
    ['.wc-home-social', 'Follow Expert - Social Media Sidebar'],
    ['.wc-news-card__media', 'News Article - Article Image', newsCardTitle],
    ['.wc-news-card__title', 'News Article - Article Title Link'],
    ['.wc-news-card__inline-more, .wc-news-card__more', 'News Article - Article Read More', newsCardTitle],
    ['.wc-news-card__author', 'News Article - Article Author'],
    ['.wc-news-pager .is-prev', 'News Pagination - News Previous', 'News'],
    ['.wc-news-pager .is-arrow', 'News Pagination - News Next', 'News'],
    ['.wc-news-pager', 'News Pagination - News Page Link', 'News'],
    ['.wc-news-social__links', 'Follow the expert'],
    ['.wc-news-rail, .wc-news-latest', 'News Page - Latest Articles Sidebar', linkTitle('.wc-news-rail__title, .wc-news-latest__title')],
    ['.wc-story-nav__link--prev', 'News Page - Previous Story', pageTitle],
    ['.wc-story-nav__link--next', 'News Page - Next Story', pageTitle],
    //legacy swapped the two here: the post is the name, the link the label
    ['.wc-author-post__title', authorPostTitle, 'Author Page - Blog post title'],
    ['.wc-author-post__more', authorPostTitle, 'Author Page - Blog post read more'],
];

//legacy labels a social link with its network
const WIZCASE_SOCIAL_AREAS = [
    'Navigation Social Media - Social Link', 'Follow the expert', 'Author Socials - Link',
    'Meet the Team - Author Social Links', 'Follow Expert - Social Media Sidebar',
];

const WIZCASE_BTN_PREFIXES = {
    'ShortcodeAffLink_': 'ShortCodeAffiliateLink_',
    'ShortcodeAffBtn_': 'ShortCodeAffiliateButton_',
};

const GAEvents = {
    parseUrl: function (url) {
        let parser = document.createElement('a');
        parser.href = url;

        return parser;
    },

    trackClick: function ($obj) {
        let href = $obj.getAttribute('href') || $obj.getAttribute('data-href');

        //a WizCase review's Compare with Alternatives tabs are buttons
        if (this.isWizCase()) {
            this.trackWizCaseClick($obj, href || '');
            return;
        }

        if (!href) {
            return;
        }

        //CATEGORY
        let category = $obj.getAttribute('data-ga-category');

        if (!category) {
            category = this.getPageName(window.location.href);
        }

        if (!category) {
            return;
        }

        //ACTION
        let action = $obj.getAttribute('data-ga-event');

        if (!action) {
            action = ($obj.getAttribute('target') && $obj.getAttribute('target') === '_blank') ? 'click out' : 'click in';

            if (action === 'click in' && (href.indexOf('http:') === 0 || href.indexOf('https:') === 0)) {
                let hostname = this.parseUrl(href).hostname;

                if (hostname.indexOf('vpns.') === -1) {
                    action = 'click out';
                }
            }
        }

        //LABEL
        let label = $obj.getAttribute('data-ga-label');

        if (!label) {
            if (action === 'click in') {
                label = 'Link: ' + this.getClickInSource($obj)  + ' -> ' + this.getClickInTarget($obj);
            } else {
                label = $obj.getAttribute('data-btn-name');

                if (!label) {
                    label = window.location.href;
                }
            }

        }

        let nonInteraction = $obj.getAttribute('data-ni');

        this.sendEvent(category, action, label, nonInteraction);
    },

    // Documentation https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits
    sendEvent: function (category, action, label, nonInteraction) {
        label = label || window.location.href;

        let paramGtag = {
                event_category: category,
                event_label: label,
            };

        if (nonInteraction) {
            paramGtag.nonInteraction = 1;
        }

        /** according to Google docs event name should contain only letters, numbers, and underscores:
         * 1) replace needed chars to underscore
         * 2) remove everything but letters, numbers, and underscores
         * 3) replace double underscore with single
         * 4) replace underscore at the end of string
         */
        action = action.replace(/[-:\s]/g, '_').replace(/[^0-9A-Za-z_]/g, '').replace(/_{2,}/g, '_').replace(/_$/, '');

        if (document.body.classList.contains('logged-in')) {
            console.log("GA Action: " + action);
            console.log(paramGtag);
        }

        if (typeof gtag !== "undefined" && window.location.host.indexOf('.int') < 0 && window.location.host.indexOf('.cc') < 0) {
            gtag('event', action, paramGtag);
        }
    },

    //PPC charts moved off legacy before the rest and keep the generic events
    isWizCase: function () {
        return (document.body.dataset.parentWebsiteId || document.body.dataset.currentWebsiteId) === 'wizcase'
            && !document.body.classList.contains('single-ppc');
    },

    /**
     * Legacy wizcase.com's events: `click out`/`click in` named by the button, labelled by the vendor.
     * A link legacy had no name for is not sent, as it was not there. See helpers\WizCaseGaEvents.
     */
    trackWizCaseClick: function ($obj, href) {
        //the accessibility widget opens its menu, and legacy had none
        if ($obj.closest('.asw-widget')) {
            return;
        }

        let vendorMatch = href.match(/\/go\/vendor\/(?:[A-Za-z0-9_-]+\/)?(\d+)/),
            area = this.getWizCaseArea($obj),
            category = $obj.getAttribute('data-ga-category') || area[0] || this.getWizCaseBtnName($obj);

        //the_content names every external link in a post "Affiliate Link"; legacy sent nothing for non-vendor ones
        if (!category || (category === 'Affiliate Link' && !vendorMatch)) {
            return;
        }

        let action = $obj.getAttribute('data-ga-event') || area[2] || (vendorMatch || this.isExternalUrl(href) ? 'click out' : 'click in'),
            label = $obj.getAttribute('data-ga-label') || area[1];

        if (!label && vendorMatch && window.wcGaVendors) {
            label = window.wcGaVendors[vendorMatch[1]];
        }

        if (!label && WIZCASE_SOCIAL_AREAS.indexOf(category) !== -1) {
            label = this.getSocialNetwork(href);
        }

        if (!label) {
            let $img = $obj.querySelector('img');

            label = $obj.textContent.trim() || $obj.getAttribute('title') || $obj.getAttribute('aria-label') || ($img ? $img.getAttribute('alt') : '');
        }

        this.sendWizCaseEvent(action, category, label || window.location.href);
    },

    /**
     * @return {string[]} the button name and, where legacy's differ from the defaults, the label and the action
     */
    getWizCaseArea: function ($obj) {
        //`[review-link]` titles itself with the vendor
        let vendorTitle = $obj.classList.contains('review-link') ? $obj.getAttribute('title') : '';

        if (vendorTitle) {
            return [vendorTitle + ' Review Link', vendorTitle, ''];
        }

        //the byline's last item, after the people
        if ($obj.classList.contains('wc-post-meta__comments-link')) {
            return ['Comment Form - Comment Link', 'Blog Comment', ''];
        }

        let $person = $obj.closest('.wc-post-meta__person');

        if ($person) {
            return [$person.previousElementSibling ? 'Fact-checked By - Fact Check Link' : 'Written By - Author Link', '', ''];
        }

        for (let i = 0; i < WIZCASE_AREAS.length; i++) {
            if ($obj.closest(WIZCASE_AREAS[i][0])) {
                let [, name, label, action] = WIZCASE_AREAS[i];

                return [
                    typeof name === 'function' ? name($obj) : name,
                    typeof label === 'function' ? label($obj) : (label || ''),
                    action || '',
                ];
            }
        }

        return ['', '', ''];
    },

    getWizCaseBtnName: function ($obj) {
        let name = $obj.getAttribute('data-btn-name') || '';

        for (let prefix in WIZCASE_BTN_PREFIXES) {
            if (name.indexOf(prefix) === 0) {
                return WIZCASE_BTN_PREFIXES[prefix] + name.substring(prefix.length);
            }
        }

        return name;
    },

    //`fr.wiz-case.com` is the same site as `www.wiz-case.com`
    isExternalUrl: function (href) {
        if (href.indexOf('http:') !== 0 && href.indexOf('https:') !== 0 && href.indexOf('//') !== 0) {
            return false;
        }

        let siteDomain = window.location.hostname.split('.').slice(-2).join('.'),
            hostname = this.parseUrl(href).hostname;

        return hostname !== siteDomain && hostname.slice(-siteDomain.length - 1) !== '.' + siteDomain;
    },

    getSocialNetwork: function (href) {
        let network = this.parseUrl(href).hostname.replace(/^www\./, '').split('.')[0];

        return network === 'x' ? 'twitter' : network;
    },

    //unlike sendEvent(), keeps the action as is: legacy's `click out` has a space
    sendWizCaseEvent: function (action, category, label) {
        let paramGtag = {
            event_category: category,
            event_label: label,
        };

        if (document.body.classList.contains('logged-in')) {
            console.log("GA Action: " + action);
            console.log(paramGtag);
        }

        if (typeof gtag !== "undefined" && window.location.host.indexOf('.int') < 0 && window.location.host.indexOf('.cc') < 0) {
            gtag('event', action, paramGtag);
        }
    },

    sendFormSubmitEvent: function (data) {
        if (typeof dataLayer !== "undefined" && window.location.host.indexOf('.int') < 0 && window.location.host.indexOf('.cc') < 0) {
            let dataLayerArguments = {
                'event': 'submit_form',
                'leadsUserData': {}
            };

            if (typeof data['email'] !== 'undefined' && data['email']) {
                dataLayerArguments.leadsUserData.sha256_email_address = sha256(data['email']);
            }

            if (typeof data['phone'] !== 'undefined' && data['phone']) {
                dataLayerArguments.leadsUserData.sha256_phone_number = sha256(data['phone']);
            }

            if (document.body.classList.contains('logged-in')) {
                console.log("Pushed 'submit_form' event to dataLayer");
                console.log(dataLayerArguments);
            }

            dataLayer.push(dataLayerArguments);
        }
    },

    getPageName: function (url) {
        let name, subpage;
        let aUrl = url.split('/');

        if (url.indexOf('http:') === 0 || url.indexOf('https:') === 0) {
            let hostname = this.parseUrl(url).hostname;

            if (hostname.indexOf('vpns.') === -1 &&
                hostname.indexOf('fund.') === -1 &&
                hostname.indexOf('finmagazin.') === -1 &&
                hostname.indexOf('finmag.') === -1 &&
                hostname.indexOf('mortgage-insiders.') === -1 &&
                hostname.indexOf('pawlicywizard.') === -1 &&
                hostname.indexOf('pawlicyguru.') === -1 &&
                hostname.indexOf('mortgage-insider.') === -1)
            {
                return '3rd party website';
            }

            name = aUrl[3];
            subpage = typeof aUrl[4] !== 'undefined' ? aUrl[4] : '';
        } else {
            name = aUrl[1];
            subpage = typeof aUrl[2] !== 'undefined' ? aUrl[2] : '';
        }

        if (typeof name === 'undefined' || name === '') {
            return 'homepage';
        }


        if (subpage !== '') {
            switch (name) {
                case 'top':
                    name = 'ppc';
                    break;
                case 'reviews':
                    name = 'review';
                    break;
                case 'categories':
                    name = 'category';
                    break;
            }
        }

        return name;
    },

    getPrefix: function ($obj) {
        let prefix = '';

        if ($obj.getAttribute('data-ga-prefix')) {
            prefix = $obj.getAttribute('data-ga-prefix') + ': ';
        } else if ($obj.classList.contains('page-numbers')) {
            prefix = 'pagination: ';
        } else if ($obj.parentNode && $obj.parentNode.classList.contains('nav-item')) {
            prefix = 'menu: ';
        } else if ($obj.closest('#breadcrumbs')) {
            prefix = 'breadcrumbs: ';
        }

        return prefix;
    },

    getSuffix: function ($obj) {
        let suffix = '';

        if ($obj.getAttribute('data-ga-suffix')) {
            suffix = ' (' + $obj.getAttribute('data-ga-suffix') + ')';
        } else if ($obj.closest('[data-popup-id]')) {
            suffix = ' (' + $obj.closest('[data-popup-id]').getAttribute('data-popup-id') + ')';
        } else if ($obj.closest('#colorbox')) {
            suffix = ' (popup)';
        } else if ($obj.closest('aside')) {
            suffix = ' (sidebar)';
        }

        return suffix;
    },

    getObjType: function ($obj) {
        let type = '';

        if ($obj.classList.contains('btn')) {
            type = ' (button)';
        } else {
            let $img = $obj.querySelector('img');
            if ($img) {
                if ($img.getAttribute('src').indexOf('avatar') !== -1) {
                    type = ' (avatar)';
                } else {
                    type = ' (image)';
                }
            }
        }

        return type;
    },

    getClickInSource: function ($obj) {
        let pageTitleNode = document.querySelector('h1'),
            pageTitle = pageTitleNode ? pageTitleNode.textContent : '';

        return this.getPageName(window.location.href) + (pageTitle ? ' (' + pageTitle + ')' : '');
    },

    getClickInTarget: function ($obj) {
        let href = $obj.getAttribute('href') || $obj.getAttribute('data-href'),
            title = this.getTitle($obj);

        return this.getPageName(href) + (title ? ' (' + title + ')' : '')
    },

    getTitle: function ($obj) {
        let title = $obj.getAttribute('title');

        if (!title) {
            title = $obj.getAttribute('data-title');
        }

        if (!title) {
            title = $obj.textContent.trim();
        }

        return title;
    },
};

window.addEventListener('load', () => {
    setTimeout(function () {

        document.addEventListener('click',function (e) {
            let tagName = e.target.tagName.toLowerCase();

            if (tagName === 'a' || e.target.getAttribute('data-ga-event')) {
                GAEvents.trackClick(e.target);
            } else if (e.target.closest('a')) {
                GAEvents.trackClick(e.target.closest('a'));
            }
        });

        //404 GA event report
        if (document.body.classList.contains('error404')) {
            let label = '';

            if (window.location.pathname) {
                label = window.location.pathname;
            }

            if (label.length > 40) {
                label = label.substr(0, 35) + '...';
            }

            GAEvents.sendEvent('error', '404')
        }
    }, 200);


    let sentEvents = [],
        ticking = false;

    window.addEventListener('scroll', function (e) {
        //WizCase static pages do not report scroll depth, see WizCaseStaticPageSeo
        if (ticking || document.body.classList.contains('no-scroll-events')) {
            return;
        }

        ticking = true;
        let pos = getScrollYPosition() + window.innerHeight,
            height = document.documentElement.scrollHeight,
            ratio = pos / height * 100;

        if (ratio < 10) {
            ticking = false;
            return;
        }

        let metricName;
        let scroll;
        if (ratio >= 90) {
            metricName = 'metric5';
            scroll = 90;
        } else if (ratio >= 75) {
            metricName = 'metric4';
            scroll = 75;
        } else if (ratio >= 50) {
            metricName = 'metric3';
            scroll = 50;
        } else if (ratio >= 25) {
            metricName = 'metric2';
            scroll = 25;
        } else {
            metricName = 'metric1';
            scroll = 10;
        }

        if (sentEvents.indexOf(scroll) !== -1) {
            ticking = false;
            return;
        }
        sentEvents.push(scroll);

        if (typeof gtag !== "undefined") {
            let gatagScrollVars = {};

            gatagScrollVars[metricName] = 1;

            gtag('set', gatagScrollVars);
        }

        if (typeof ga !== "undefined") {
            ga('set', metricName, 1);
        }

        GAEvents.sendEvent('Scroll tracking', 'Scroll ' + scroll + '%', window.location.href, true);
        ticking = false;
    }, {passive: true});

    function getScrollYPosition() {
        let supportPageOffset = window.pageYOffset !== undefined;
        let isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

        return supportPageOffset
            ? window.pageYOffset
            : (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
    }
});

window.GAEvents = GAEvents;
export default GAEvents;

